import Vue from 'vue';
import Router from 'vue-router';
import Scoreboard from './views/Scoreboard.vue';

Vue.use(Router);

export default new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'scoreboard',
      component: Scoreboard,
    },
  ],
});
